import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Slider,
    Typography,
    Box,
    Avatar
} from '@mui/material';

/**
 * Modal waarmee uitgeschakelde deelnemers een speler beschikbaar kunnen stellen voor de Draft.
 * De deelnemer kan een winstpercentage (0-15%) opgeven.
 */
function DraftOfferModal({ open, onClose, player, onConfirm, currentOfferCount }) {
    const [profitPercentage, setProfitPercentage] = useState(0);

    const handleConfirm = () => {
        if (player) {
            onConfirm(player, profitPercentage);
            setProfitPercentage(0);
        }
    };

    const handleClose = () => {
        setProfitPercentage(0);
        onClose();
    };

    const maxOffersReached = currentOfferCount >= 3;

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Speler beschikbaar stellen voor Draft</DialogTitle>
            <DialogContent>
                {player && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: 1 }}>
                        <Avatar src={player.photoUrl} alt={player.name} sx={{ width: 56, height: 56 }} />
                        <Box>
                            <Typography variant="h6">{player.name}</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {player.clubName} &middot; {player.position}
                            </Typography>
                        </Box>
                    </Box>
                )}

                {maxOffersReached ? (
                    <DialogContentText color="error">
                        Je hebt al 3 spelers beschikbaar gesteld. Je kunt niet meer spelers aanbieden.
                    </DialogContentText>
                ) : (
                    <>
                        <DialogContentText sx={{ mb: 2 }}>
                            Stel een winstpercentage in (0-15%). Dit is het percentage van het prijzengeld dat naar jou gaat
                            als de koper van deze speler het spel wint.
                        </DialogContentText>

                        <Typography gutterBottom>
                            Winstpercentage: <strong>{profitPercentage}%</strong>
                        </Typography>
                        <Slider
                            value={profitPercentage}
                            onChange={(e, val) => setProfitPercentage(val)}
                            min={0}
                            max={15}
                            step={1}
                            marks={[
                                { value: 0, label: '0%' },
                                { value: 5, label: '5%' },
                                { value: 10, label: '10%' },
                                { value: 15, label: '15%' }
                            ]}
                            valueLabelDisplay="auto"
                        />
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Annuleren</Button>
                <Button
                    onClick={handleConfirm}
                    color="primary"
                    variant="contained"
                    disabled={maxOffersReached}
                >
                    Beschikbaar stellen
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DraftOfferModal;
